export default {
  namespace: 'global',

  state: {
    collapsed: false,
    curBreadcrumbsList: [],
  },

  effects: {
    * setCurBreadcrumbsList({ payload: curPathName }, { put, select }) {
      const routerPathMap = yield select(state => state.menu.routerPathMap)
      const isEmpty = Object.keys(routerPathMap).length === 0
      if (isEmpty) {
        return
      }
      function getCurBreadcrumbsList(
        routerPathMap,
        pathName,
        curBreadcrumbsList = [],
      ) {
        const pathConf = routerPathMap[pathName]

        if (pathConf) {
          curBreadcrumbsList.unshift({
            path: pathConf.path,
            breadcrumbName: pathConf.title,
          })
          if (pathConf.parentPath) {
            getCurBreadcrumbsList(
              routerPathMap,
              pathConf.parentPath,
              curBreadcrumbsList,
            )
          }
        }

        return curBreadcrumbsList
      }

      const curBreadcrumbsList = getCurBreadcrumbsList(
        routerPathMap,
        curPathName,
      )

      curBreadcrumbsList.unshift({
        path: '/',
        breadcrumbName: '首页',
      })

      yield put({
        type: 'save',
        payload: {
          curBreadcrumbsList,
        },
      })
    },
  },

  reducers: {
    save(state, action) {
      return {
        ...state,
        ...action.payload,
      }
    },
    changeLayoutCollapsed(state, { payload }) {
      return {
        ...state,
        collapsed: payload,
      }
    },
  },

  subscriptions: {
    setup({ history, dispatch }) {
      return history.listen(({ pathname }) => {
        dispatch({
          type: 'setCurBreadcrumbsList',
          payload: pathname,
        })
        dispatch({
          type: 'menu/setMenuKeys',
          payload: pathname,
        })
      })
    },
  },
}
